module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA7YAAAI4AQMAAABk+efHAAAAA1BMVEX///+nxBvIAAAAAXRSTlNNSIvlSwAAAGVJREFUeNrswYEAAAAAgKD9qRepAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADg9uCQAAAAAEDQ/9dusAMAAAAAAADAFApPAAHck6d2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/zhezhao.png
// module id = 4vNs
// module chunks = 0